// extracted by mini-css-extract-plugin
export default {"root":"SignIn_root__DjFQL","image":"SignIn_image__0T5XF","image__notfoundtext":"SignIn_image__notfoundtext__ghzPh","image__announce":"SignIn_image__announce__clNe6"};